import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { UserAction } from '../user.action';
import { UserTranslator } from '../user.translator';

type IDependencies = IClientApiDependencySegment;

export const createClientUserEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(UserAction.create),
  mergeMap((payload) => {
    const { user, reject } = payload;

    return dependencies.api.createUser(UserTranslator.toApi(user)).pipe(
      mergeMap((response) => {
        const { userId } = response;

        return [
          UserAction.createDone({ userId }),
          DetailsSidebarAction.close(),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          UserAction.createFailed(),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
